import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { Y3GraphComponent } from './components/y3-graph/y3-graph.component';
import { Y3PieChartComponent } from './components/y3-pie-chart/y3-pie-chart.component';
import { Y3BarChartComponent } from './components/y3-bar-chart/y3-bar-chart.component';
import { MatProgressSpinnerModule} from '@angular/material/progress-spinner';
import { ProgressSpinnerComponent } from '../common-components/progress-spinner/progress-spinner.component';
import { Y3EnergyOverviewChartComponent } from './components/y3-energy-overview-chart/y3-energy-overview-chart.component';
import { Y3DonutChartComponent } from './components/y3-donut-chart/y3-donut-chart.component';
import { Y3AvgDailyTempComponent } from './components/y3-avg-daily-temp/y3-avg-daily-temp.component';
import { Y3SwitchGraphsComponent } from './components/y3-switch-graphs/y3-switch-graphs.component';
import { DemoAccountService } from '../demo-account.service';
import { GlobalVariablesService } from '../services/global-variables.service';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import { MatDialogRef } from '@angular/material/dialog';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';

@NgModule({
  imports: [
    CommonModule,
    MatProgressSpinnerModule,
    MatSlideToggleModule,
  ],
  declarations: [Y3GraphComponent, Y3PieChartComponent, Y3BarChartComponent, ProgressSpinnerComponent, Y3EnergyOverviewChartComponent
    , Y3DonutChartComponent, Y3AvgDailyTempComponent, Y3SwitchGraphsComponent],
  exports: [
    Y3GraphComponent,
    Y3PieChartComponent,
    Y3BarChartComponent,
    Y3EnergyOverviewChartComponent,
    Y3DonutChartComponent,
    Y3AvgDailyTempComponent,
    Y3SwitchGraphsComponent,
  ],
  providers: [
    DemoAccountService,
    {
      provide: MatDialogRef,
      useValue: {}
  }
  ]
})
export class LdsGraphModule { }
